<template>
  <div>
    <v-btn
      class="text-none"
      v-if="isOpen"
      color="primary"
      :class="{
        'mr-4 btn-text': $vuetify.breakpoint.mdAndUp,
        'mobile-btn-text': !$vuetify.breakpoint.mdAndUp
      }"
      @click="onSigninClick"
      depressed
      light
      dense
      text
      :large="$vuetify.breakpoint.mdAndUp"
      rounded
      >Đăng nhập</v-btn
    >
    <v-btn
      color="orange"
      class="text-none white--text"
      v-if="isOpen"
      :class="{
        'mr-4 btn-text': $vuetify.breakpoint.mdAndUp,
        'mobile-btn-text': !$vuetify.breakpoint.mdAndUp
      }"
      @click="onSignupClick"
      elevation="0"
      dense
      rounded
      :large="$vuetify.breakpoint.mdAndUp"
      >{{ $vuetify.breakpoint.mdAndUp ? 'Đăng ký' : 'Đăng ký' }}</v-btn
    >

    <!-- Tạm ẩn phần chọn khối: đăng ký mặc định vào Khối 1.
    <v-dialog v-model="gradeSelectionDialog" max-width="554px">
      <v-card>
        <v-card-title>
          <div class="title--text">Chọn khối đăng ký</div>
          <v-spacer />
          <v-icon @click="gradeSelectionDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions
          class="pa-4 d-flex"
          :class="{
            'justify-space-around': $vuetify.breakpoint.mdAndUp,
            'flex-column': $vuetify.breakpoint.smAndDown
          }"
        >
          <v-card
            class="d-flex flex-column align-center elevation-0 rounded-lg border-btn"
            :class="{
              'mb-4 btn-overlay': $vuetify.breakpoint.smAndDown,
              'desktop-btn mr-4': $vuetify.breakpoint.mdAndUp
            }"
            @click="selectGrade('primary')"
          >
            <v-img src="@/assets/icon_info_g1.svg" class="mb-4 mt-6" width="141" height="114" />
            <div style="width: 85%;">
              <v-divider class="primary" />
            </div>
            <div class="primary--text font-weight-medium my-6" style="line-height: 24px">
              Đăng ký cho <span style="font-size: 20px;">Khối 1</span>
            </div>
          </v-card>
          <v-card
            class="d-flex flex-column align-center elevation-0 rounded-lg border-btn"
            :class="{
              'btn-overlay': $vuetify.breakpoint.smAndDown,
              'desktop-btn': $vuetify.breakpoint.mdAndUp
            }"
            @click="selectGrade('high')"
          >
            <v-img src="@/assets/icon_info_g10.svg" class="mb-4 mt-6" width="141" height="114" />
            <div style="width: 85%;">
              <v-divider class="primary" />
            </div>
            <div class="primary--text font-weight-medium my-6" style="line-height: 24px">
              Đăng ký cho <span style="font-size: 20px;">Khối 10</span>
            </div>
          </v-card>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
export default {
  props: {
    isOpen: Boolean
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'user', 'isConfirmedOTP']),
    ...mapGetters('site', ['siteLevel'])
  },
  methods: {
    ...mapActions('layout', ['setSignUpDialog', 'setSignInDialog', 'setAllDialogClose', 'setConfirmSignupDialog']),
    ...mapMutations('layout', ['setGrade']),
    onSigninClick() {
      this.setAllDialogClose()
      this.setSignInDialog(true)
    },
    onSignupClick() {
      this.setAllDialogClose()
      if (this.isAuthenticated && this.user && !this.isConfirmedOTP) {
        this.setConfirmSignupDialog(true)
      } else {
        this.setGrade(this.siteLevel || 'primary')
        this.setSignUpDialog(true)
      }
    }
  }
}
</script>
<style scoped>
.btn-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.mobile-btn-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px !important;
  line-height: 16px;
}
.border-btn {
  border: 1.22px solid #224189;
}
.desktop-btn {
  width: 50%;
  position: relative;
}
.btn-overlay {
  width: 100%;
  position: relative;
}
.btn-overlay:hover {
  background-color: #ecf1fd !important;
}
</style>
